import { initMap } from './components/openlayers-map-draw-locators.js';

initMap();
